<template>

<div style="padding-top: 8px;">
    <div class="sub-small"> {{ params.data.source.name }}</div>
    <div class="small"> {{ params.data.source.owner[0] ? params.data.source.owner[0].email : '' }}</div>
</div>

</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.small {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.107143px;
  color: #2c2c2c;
  max-width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sub-small {
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.107143px;
  color: #2c2c2c;
  max-width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>